import { useState } from "react";
import OverviewModal from "../../../components/shared/modalContent/OverviewModal";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import KgEntered from "../../../images/material_kg.svg";
import ColdStorageKg from "../../../images/material_orange.svg";
import TotalCase from "../../../images/totalCase.svg";
import { useSearchRecordQuery } from "../coldStorage/coldstorageApi";
import ColdStorageModal from "../coldStorage/ColdStorageModal";
import TotalRipening from "../../../images/ripening_orange.svg";
import "./ripeningRoom.css";
import RoomCard from "./RoomCard";
import { useGetRoomsQuery } from "./ripeningApi";
import RoomById from "./RoomById";
import { useGetRipeningSummaryQuery } from "../dashboard/ripeingDashboardApi";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone } from "../../../helpers/Utils";
const RipeningRoom = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(3);
  const [showModal, setShowModal] = useState(false);
  const [room, setRoom] = useState(null);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const currentDate = convertToUserTimezone(null, "YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("ripening");
  const { data: summaryData } = useGetRipeningSummaryQuery(
    { tab },
    { refetchOnMountOrArgChange: true },
  );
  // const {
  //   data: record,
  //   isLoading,
  //   isError,
  //   error,
  // } = useSearchRecordQuery({ page, pageSize });
  const { data: roomData, isLoading: isRoomLoading, isFetching: isRoomFetching } = useGetRoomsQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );
  const { _t } = useTranslator();

  const roomDetails = roomData?.data;
  const listItems = [
    // {
    //   label: _t("total_on_floor_cases", "Total on Floor Cases"),
    //   value: summaryData?.data.total_cases_on_floor,
    //   icon: TotalCase,
    // },
    // {
    //   label: _t("total_kg_on_floor", "Total on Floor cases in KG"),
    //   value: summaryData?.data.total_kg_on_floor,
    //   icon: KgEntered,
    // },
    {
      label: _t("total_cases_in_rooms", "Total Cases Entered in Rooms"),
      value: summaryData?.data.total_cases_in_rooms,
      icon: TotalRipening,
    },
    {
      label: _t("total_weight_in_rooms", "Total Weight Entered in Rooms"),
      value: summaryData?.data.total_weight_in_rooms,
      icon: ColdStorageKg,
    },
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };
  const handleAddRecord = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };
  const handleView = (room) => {
    setRoom(room);
  };
  const handleEdit = (unloading) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(unloading);
    setShowModal(true);
  };
  const getStatus = (row) => {
    const expectedDateMs = convertToUserTimezone(
      row?.row?.expected_date_to_ripening,
      undefined,
      undefined,
      "valueOf",
    );
    const nowMs = convertToUserTimezone(null, undefined, undefined, "valueOf");

    if (Number.isNaN(expectedDateMs)) {
      return "Cold Stored";
    }

    if (row?.row?.status === "cold_stored" && nowMs < expectedDateMs) {
      return "Cold Stored";
    } else if (row?.row?.status === "cold_stored" && nowMs >= expectedDateMs) {
      return "Ready For Ripening";
    } else {
      return "Ripening";
    }
  };

  return room ? (
    <RoomById room={room} setShow={setRoom} />
  ) : (
    <div>
      {addRecord && (
        <ColdStorageModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
        />
      )}
      {showOverviewModal && (
        <OverviewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          record={selectedRecord}
          mode="unloading"
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("ripening_rooms_overview", "Ripening Rooms Overview")}
          </h6>
          {/* <DateSelector setDate={setDate} /> */}
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              // day={currentDate === date ? _t("today", "Today") : date}
            />
          ))}
        </ul>
      </div>
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("room_data", "Room Data")}</h6>
        </div>
        <div className="cards_gridwrapper gap-2 p-3">
          {(isRoomLoading || isRoomFetching) && (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          )}
          {!isRoomLoading && !isRoomFetching && roomDetails?.map((list, index) => (
            <RoomCard
              key={index}
              roomDetails={list}
              handleView={() => handleView(list)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RipeningRoom;
